module.exports = __webpack_public_path__ + "static/media/Brow01.1cde03d9.jpeg";